export default "__VITE_ASSET__Bz5ni1xG__"